module.exports = __webpack_public_path__ + "static/media/print-logo-5.c331020f.png";